import { render, staticRenderFns } from "./newReview.vue?vue&type=template&id=40459281&"
import script from "./newReview.vue?vue&type=script&lang=js&"
export * from "./newReview.vue?vue&type=script&lang=js&"
import style0 from "./newReview.vue?vue&type=style&index=0&id=40459281&prod&lang=scss&scope=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports